<script setup lang="ts">
import { ref } from 'vue';

interface LoaderProps {
  type: 'content' | 'simple' | 'overlay';
  text?: string;
}

const props = withDefaults(defineProps<LoaderProps>(), {
  text: undefined,
});
const showOverlay = ref(props.type === 'overlay');
</script>

<template>
  <div
    :class="{
      content: type === 'content',
      overlay: type === 'overlay',
    }"
  >
    <v-overlay
      v-if="type === 'overlay'"
      v-model="showOverlay"
      :persistent="true"
      :noClickAnimation="true"
      class="align-center justify-center"
      scrim="secondary-darken-4"
    >
      <div class="d-flex flex-column align-center justify-center">
        <div class="loader">
          <div />
          <div />
          <div />
        </div>
        <p v-if="text" class="mt-6 text-off-white text-h5">{{ text }}</p>
      </div>
    </v-overlay>
    <div v-else class="loader">
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loader {
  position: relative;
  width: 10rem;
  height: 10rem;

  div {
    position: absolute;
    border-color: rgb(var(--v-theme-on-primary));
    border-width: 2px;
    border-style: solid;
    border-radius: 50%;
    animation: load 2.5s ease-out infinite;

    top: 1rem;
    left: 1rem;

    width: 8rem;
    height: 8rem;

    transform: scale(0.1);
    transform-origin: center center;

    &:nth-child(2) {
      animation-delay: -0.6s;
    }
    &:nth-child(3) {
      animation-delay: -1s;
    }
  }
}
.content {
  width: 100%;
  min-height: 200px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    div {
      border-color: rgb(var(--v-theme-secondary));
    }
  }
}

// Loader keyframe animation
@keyframes load {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.2;
    transform: scale(0.1);
  }
  10% {
    opacity: 0.4;
    transform: scale(0.2);
  }
  20% {
    opacity: 1;
    border-width: 10px;
  }
  95% {
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
